import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BaseOption } from 'src/app/model/BaseOption';
import { SessionService } from 'src/app/session-service.service';
import { BaseComponent } from '../BaseComponent';
import { filter } from 'rxjs/operators';
import { ComponentCommunicationService } from '../../component-communication.service';

@Component({
  selector: 'app-autocomplete-input',
  templateUrl: './autocomplete-input.component.html',
  styleUrls: ['./autocomplete-input.component.css'],
})
export class AutocompleteInputComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  dataSource: BaseOption[] = [];
  @Input()
  isDefaultValueSetAfterOptionListChanged = true;
  @Input()
  fontFamily: any;

  @Input()
  fontColor: any;

  @Input()
  fontSize: string;

  @Input()
  inputColor: string;

  @Input()
  inputBorderColor: string;

  @Input()
  additionalInfoInsurer: string;

  controlType = this.constructor.name;
  filteredOptions: BaseOption[];
  myControl: FormControl;

  valueChangesSubscription: Subscription;

  constructor(
    translateService: TranslateService,
    public sessionService: SessionService,
    private componentCommunicationService: ComponentCommunicationService
  ) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    if (!this.dataSource) {
      this.dataSource = [];
    }
    super.ngOnInit();

    let initialValue = '';

    if (this.control.value) {
      initialValue = this.getTextFromValue(this.control.value);
    }

    this.myControl = new FormControl(initialValue);
    if (this.control.validator) {
      const validator = this.control.validator({}as AbstractControl);
      if (validator && validator.required) {
        this.myControl.setValidators(Validators.required);
      }
    }

    this.valueChangesSubscription = this.myControl.valueChanges.pipe()
      .subscribe(newValue => {
      this.filteredOptions = this._filter(newValue);
      const value = this.getValueFromText(newValue);
      this.control.patchValue(value);
    });
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'dataSource': {
            if (!this.dataSource || !this.isDefaultValueSetAfterOptionListChanged) {
              return;
            }
            if (this.control.value) {
              const initialValue = this.getTextFromValue(this.control.value);
              this.myControl?.patchValue(initialValue);
            }
          }
        }
      }
    }
  }

  getTextFromValue(value: string): string {
    const searchValue = value?.toLowerCase();
    const result = this.dataSource.find((option) =>
      option.value.toLowerCase().includes(searchValue)
    );

    return result?.text;
  }

  getValueFromText(text: string): string {
    const searchValue = text?.toLowerCase();
    const result = this.filteredOptions.find((option) =>
      option.text.toLowerCase() === searchValue
    );
    if (!result) {
      return null;
    }

    return result.value;
  }

  private _filter(value: string): BaseOption[] {
    const filterValue = value.toLowerCase();

    return this.dataSource.filter((option) =>
      option.text.toLowerCase().includes(filterValue)
    );
  }

  openPopup(): void{
    this.componentCommunicationService.loadDialog(this.additionalInfoInsurer);
  }

}
